// Community Vote Management APIs

/**
 * @function ApiClient#GetVoteList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.voteByHouseHold
 * @param {any} params.important
 * @param {any} params.canMessage
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetVoteList(
  cid,
  { sortBy, sortDesc, page, itemsPerPage, startDate, endDate, voteByHouseHold, important, canMessage, search },
  options = {},
) {
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";
  if (!voteByHouseHold) voteByHouseHold = "";
  if (!important) important = "";
  if (!canMessage) canMessage = "";
  if (!search) search = "";

  return await this._get(
    `/community/${cid}/vote_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&vh=${voteByHouseHold}&imp=${important}&cm=${canMessage}&ss=${search}`,
    options,
  );
}

/**
 * @function ApiClient#GetOptionVoteList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} vid
 * @param {any} qid
 * @param {any} oid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} options = {}
 */
export async function GetOptionVoteList(cid, vid, qid, oid, { sortBy, sortDesc, page, itemsPerPage }, options = {}) {
  return await this._get(`/community/${cid}/vote/${vid}/${qid}/${oid}/vote_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}`, options);
}

/**
 * @function ApiClient#AddVote
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteData
 * @param {any} files
 * @param {any} images
 * @param {any} options = {}
 */
export async function AddVote(cid, voteData, files, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(voteData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  if (images) {
    images.forEach((i) => {
      formData.append("Image", i);
    });
  }

  return await this._post(`/community/${cid}/vote`, formData, options);
}

/**
 * @function ApiClient#UpdateVote
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteData
 * @param {any} files
 * @param {any} images
 * @param {any} options = {}
 */
export async function UpdateVote(cid, voteData, files, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(voteData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  if (images) {
    images.forEach((i) => {
      formData.append("Image", i);
    });
  }

  return await this._put(`/community/${cid}/vote`, formData, options);
}

/**
 * @function ApiClient#NotifyVoteAgain
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteID
 * @param {any} options = {}
 */
export async function NotifyVoteAgain(cid, voteID, options = {}) {
  return await this._post(`/community/${cid}/vote/${voteID}/notify_again`, null, options);
}

/**
 * @function ApiClient#PublishVote
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteID
 * @param {any} options = {}
 */
export async function PublishVote(cid, voteID, options = {}) {
  return await this._put(`/community/${cid}/vote/${voteID}/publish`, null, options);
}

/**
 * @function ApiClient#GetVoteMessageList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteID
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.search
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetVoteMessageList(
  cid,
  voteID,
  { sortBy, sortDesc, page, itemsPerPage, startDate, endDate, search, building, doorPlate, floor },
  options = {},
) {
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";
  if (!search) search = "";
  if (!building) building = "";
  if (!doorPlate) doorPlate = "";
  if (!floor) floor = "";

  return await this._get(
    `/community/${cid}/vote/${voteID}/message_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&ss=${search}&b=${building}&d=${doorPlate}&f=${floor}`,
    options,
  );
}

/**
 * @function ApiClient#SetVoteMessageHide
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteID
 * @param {any} messageID
 * @param {any} options = {}
 */
export async function SetVoteMessageHide(cid, voteID, messageID, options = {}) {
  return await this._put(`/community/${cid}/vote/${voteID}/message/${messageID}/hide`, null, options);
}

/**
 * @function ApiClient#UnsetVoteMessageHide
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteID
 * @param {any} messageID
 * @param {any} options = {}
 */
export async function UnsetVoteMessageHide(cid, voteID, messageID, options = {}) {
  return await this._delete(`/community/${cid}/vote/${voteID}/message/${messageID}/hide`, null, options);
}

/**
 * @function ApiClient#DeleteVote
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} voteID
 * @param {any} options = {}
 */
export async function DeleteVote(cid, voteID, options = {}) {
  return await this._delete(`/community/${cid}/vote/${voteID}`, options);
}
